import { TimetablesPage } from '@features/timetables/components/TimetablesPage'
import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/timetables')({
    component: TimetablesPage,
    beforeLoad: requireRouteAudience(['staff']),
    staticData: {
        crumb: {
            label: 'Timetables',
        },
    },
})
